import { useLiteSiteStore } from "../store";

export function useScrollBookingIntoView(dateString: string) {
  const storeBookingDate = useLiteSiteStore(({ scrollBookingIntoView }) => scrollBookingIntoView);
  return storeBookingDate === dateString;
}
